/**
 * Collab 도메인 배럴
 * @description 앱 `domains/core/collab` · `collabV3` 의 웹 대응. 2.0 상세는 아직 `shared/lib/collabs` 에
 *   있고(콜랩 상세 페이지가 먼저 만들어졌다), 목록과 3.0 상세가 이 자리에 있다.
 */
export type {
  CollabListItem,
  CollabListItemVersion,
  GetCollabListQuery,
  GetCollabListResponse,
} from "./dtos";
export { getCollabs } from "./repositories/collabListRepository";
export { loadCollabs } from "./actions/loadCollabs";

// ── 상세(2.0 · 3.0 콜랩 모두 3.0 화면, 보기 전용) ──
export type {
  CollabV3DetailDto,
  CollabV3ThreadDto,
  CollabV3WorksDto,
} from "./dtos";
export type {
  CollabV3Detail,
  CollabV3Thread,
  CollabV3WorkPreview,
} from "./entities";
export {
  getCollabV3Detail,
  getCollabV3Thread,
  getCollabV3WorkPreviews,
} from "./repositories/collabV3Repository";
export {
  toCollabV3EventSubject,
  type CollabV3EventSubject,
} from "./analytics";
export { COLLAB_V3_TEASER } from "./constants/collabV3Teaser";
export * from "./components/detailV3";
